import { trackClientEvent } from '../../../../trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey =
  'product_info-eco_friendly_information_accordion_view-view';

/**
 * The user views the Eco-friendly information accordion, within the PDP
 */
export function trackProductInfoEcoFriendlyInformationAccordionViewView(): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
  });
}
